"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-nested-ternary */
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_router_dom_1 = require("react-router-dom");
const assets_1 = require("~/assets");
const utils_1 = require("~/utils/utils");
const UI_1 = require("~/components/UI");
const accountTabs_1 = require("~/consts/accountTabs");
const consts_1 = require("~/consts/consts");
const routes_1 = require("~/consts/routes");
const useCurrentAccountTabId_1 = __importDefault(require("~/hooks/useCurrentAccountTabId"));
const useInfiniteFetch_1 = __importDefault(require("~/hooks/useInfiniteFetch"));
const useIntersectionObserver_1 = __importDefault(require("~/hooks/useIntersectionObserver"));
const actions_1 = require("~/store/actions");
const redux_1 = require("redux");
const react_redux_1 = require("react-redux");
const selectors_1 = require("~/store/selectors");
const react_helmet_async_1 = require("react-helmet-async");
const consts_2 = require("./consts");
const CustomerDetails_1 = __importDefault(require("./CustomerDetails"));
const CustomerItem_1 = __importDefault(require("./CustomerItem"));
const CustomersModal_module_scss_1 = __importDefault(require("./CustomersModal.module.scss"));
function CustomersModal() {
    (0, useCurrentAccountTabId_1.default)(accountTabs_1.TAB_IDS.CUSTOMERS);
    const { t } = (0, react_i18next_1.useTranslation)('customer');
    const navigate = (0, react_router_dom_1.useNavigate)();
    const loader = (0, react_1.useRef)(null);
    const intersectionObserver = (0, useIntersectionObserver_1.default)(loader);
    const [selected, setSelected] = (0, react_1.useState)(null);
    const [customers, setCustomers] = (0, react_1.useState)(null);
    const [searchIconVisible, setSearchIconVisible] = (0, react_1.useState)(true);
    const [filterActive, setFilterActive] = (0, react_1.useState)(false);
    const [page, setPage] = (0, react_1.useState)(0);
    const [field, setField] = (0, react_1.useState)('firstName');
    const [sort, setSort] = (0, react_1.useState)('ASC');
    const [forceRefresh, setForceRefresh] = (0, react_1.useState)(false);
    const [search, setSearch] = (0, react_1.useState)('');
    const [distributorDiscount, setDistributorDiscount] = (0, react_1.useState)(null);
    const [isAddButtonLabelSet, setIsAddButtonLabelSet] = (0, react_1.useState)(false);
    const [addButtonLable, setAddButtonLabel] = (0, react_1.useState)('');
    const distributorDiscounts = (0, react_redux_1.useSelector)(selectors_1.selectCurrentUserDiscounts);
    (0, react_1.useEffect)(() => {
        if (distributorDiscounts) {
            setDistributorDiscount(distributorDiscounts.find((discount) => (0, utils_1.isDiscountValid)([consts_1.DISCOUNT_TYPE.SPECIAL_PRICE_AGREEMENT], discount)) ||
                distributorDiscounts.find((discount) => (0, utils_1.isDiscountValid)([consts_1.DISCOUNT_TYPE.DISTRIBUTOR], discount)) ||
                null);
        }
    }, [distributorDiscounts]);
    const { loading, result } = (0, useInfiniteFetch_1.default)({
        query: `${process.env.API_HOSTNAME}/api${routes_1.ROUTE_CUSTOMERS}`,
        page,
        field,
        sort,
        forceRefresh,
        search,
        limit: 20,
    });
    const { dispatchGetUserDiscounts } = (0, redux_1.bindActionCreators)({
        dispatchGetUserDiscounts: actions_1.getUserDiscounts,
    }, (0, react_redux_1.useDispatch)());
    (0, react_1.useEffect)(() => {
        dispatchGetUserDiscounts();
        setAddButtonLabel(t('actions.create'));
    }, []);
    (0, react_1.useEffect)(() => setPage(0), [field, sort, search]);
    (0, react_1.useEffect)(() => {
        if (result) {
            if (!isAddButtonLabelSet) {
                setAddButtonLabel(result.length ? t('actions.add') : t('actions.create'));
                setIsAddButtonLabelSet(true);
            }
            if (page === 0) {
                setForceRefresh(false);
            }
            const customerDataList = result.map((userData) => {
                var _a, _b;
                const customerData = Object.assign({}, userData);
                customerData.activeSpecialDiscount = (_a = customerData.discounts) === null || _a === void 0 ? void 0 : _a.find((discount) => (0, utils_1.isDiscountValid)([consts_1.DISCOUNT_TYPE.SPECIAL_PRICE_AGREEMENT], discount));
                customerData.activeCustomerDiscount = (_b = customerData.discounts) === null || _b === void 0 ? void 0 : _b.find((discount) => (0, utils_1.isDiscountValid)([consts_1.DISCOUNT_TYPE.CUSTOMER], discount));
                return customerData;
            });
            setSelected(customerDataList.length ? customerDataList[0] : null);
            setCustomers(customerDataList);
        }
        else {
            setSelected(null);
            setCustomers(loading ? null : []);
        }
    }, [result, loading]);
    (0, react_1.useEffect)(() => {
        if (intersectionObserver) {
            setPage((prev) => prev + 1);
        }
    }, [intersectionObserver]);
    const searchHandler = (0, utils_1.debounce)(500, (value) => setSearch(value));
    const handleFilterClick = () => {
        setFilterActive((prevState) => !prevState);
    };
    const onKeyDownHandler = (event) => {
        if (event.key === 'Enter' || event.key === 'Accept' || event.key === ' ') {
            setFilterActive(!filterActive);
        }
    };
    const getCustomerItemOptions = () => {
        const options = {
            edit: t('actions.edit-discount'),
        };
        return options;
    };
    const handleOptionClick = (0, react_1.useCallback)((key) => {
        if (key === 'edit' && selected) {
            navigate(routes_1.ROUTE_EDIT_CUSTOMER.replace(':customerId', String(selected.id)));
        }
    }, [selected]);
    const getMainContent = () => {
        if (!customers) {
            return undefined;
        }
        if (customers.length) {
            return (react_1.default.createElement("div", { className: CustomersModal_module_scss_1.default.main, "data-scrollbar": customers.length > 6 },
                react_1.default.createElement("table", null,
                    react_1.default.createElement("thead", null,
                        react_1.default.createElement("tr", null,
                            react_1.default.createElement("th", { className: CustomersModal_module_scss_1.default[consts_1.HEADER_ITEM] }, t('information.first-name')),
                            react_1.default.createElement("th", { className: CustomersModal_module_scss_1.default[consts_1.HEADER_ITEM] }, t('information.last-name')),
                            react_1.default.createElement("th", { className: CustomersModal_module_scss_1.default[consts_1.HEADER_ITEM] }, t('information.company')))),
                    react_1.default.createElement("tbody", null,
                        customers.map((customer) => {
                            return (react_1.default.createElement(CustomerItem_1.default, { customer: customer, key: customer.id, selected: customer.id === (selected === null || selected === void 0 ? void 0 : selected.id), onSelect: setSelected, options: getCustomerItemOptions(), onOptionClick: handleOptionClick }));
                        }),
                        customers.length > 19 ? react_1.default.createElement("div", { ref: loader }) : null))));
        }
        return (react_1.default.createElement("div", { className: CustomersModal_module_scss_1.default['no-customers-container'] }, search ? (react_1.default.createElement("div", { className: CustomersModal_module_scss_1.default['not-found'] },
            t('messages.no-results-found-by'),
            " ",
            react_1.default.createElement("b", null, search))) : (react_1.default.createElement("div", { className: CustomersModal_module_scss_1.default['no-customers'] },
            react_1.default.createElement("img", { src: assets_1.svgBasicHideIcon, alt: "No Customers" }),
            react_1.default.createElement("div", null, t('messages.no-customers'))))));
    };
    const getSidebarContent = () => {
        var _a, _b;
        if (customers) {
            if (selected) {
                return (react_1.default.createElement(CustomerDetails_1.default, { customer: selected, distributirDiscount: distributorDiscount, sharedProjectsAmount: (_b = (_a = selected === null || selected === void 0 ? void 0 : selected.projects) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0 }));
            }
            if (!selected && search) {
                return react_1.default.createElement("div", { className: CustomersModal_module_scss_1.default['no-selected'] }, t('messages.n-a'));
            }
            return react_1.default.createElement("div", { className: CustomersModal_module_scss_1.default['no-selected'] }, t('messages.no-selected-customer'));
        }
        return react_1.default.createElement(UI_1.ContentListModalSidebarLoader, null);
    };
    return (react_1.default.createElement(UI_1.ContentListModal, { headlineContent: react_1.default.createElement("div", { className: CustomersModal_module_scss_1.default.header },
            react_1.default.createElement(react_helmet_async_1.Helmet, null,
                react_1.default.createElement("title", null, "Customers | TBUILD")),
            react_1.default.createElement("div", { className: CustomersModal_module_scss_1.default.title }, t('customers')),
            react_1.default.createElement("div", { className: CustomersModal_module_scss_1.default.controls },
                react_1.default.createElement(react_router_dom_1.Link, { to: routes_1.ROUTE_ADD_CUSTOMER, className: CustomersModal_module_scss_1.default['create-button'] },
                    react_1.default.createElement("img", { src: assets_1.svgBasicAddNew, alt: "Add a customer" }),
                    addButtonLable),
                react_1.default.createElement("div", { className: CustomersModal_module_scss_1.default['sorting-container'], "data-disabled": !(customers === null || customers === void 0 ? void 0 : customers.length) },
                    react_1.default.createElement(UI_1.ElementDropdown, { hideOnSelect: false, element: 
                        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
                        react_1.default.createElement("img", { src: assets_1.svgBasicSorting, className: CustomersModal_module_scss_1.default['sorting-button'], "data-active": filterActive, "data-disabled": !(customers === null || customers === void 0 ? void 0 : customers.length), onClick: handleFilterClick, onKeyDown: onKeyDownHandler, alt: "Sorting" }), placement: "bottom-end", dropdown: react_1.default.createElement(UI_1.SortingDropdown, { options: consts_2.sortingOptions, field: field, order: sort, setField: setField, setOrder: setSort }), activeStateHandler: setFilterActive })),
                react_1.default.createElement("div", { className: CustomersModal_module_scss_1.default.search, "data-empty": searchIconVisible, "data-disabled": !(customers === null || customers === void 0 ? void 0 : customers.length) && !search },
                    react_1.default.createElement(UI_1.Input, { type: "search", onInput: (value) => {
                            setSearchIconVisible(!value);
                            searchHandler(value);
                        }, placeholder: t('actions.search-customer') })))), mainContent: getMainContent(), sidebar: getSidebarContent() }));
}
exports.default = CustomersModal;
